import React, { useContext, useEffect } from 'react';
import { useError } from '@avon/component-library';
import RepCardContainer from '../RepCardContainer';
import ProfileContainer from '../ProfileContainer';
import PmaContext from '../../PmaContext';
import SkeletonLoader from '../SkeletonLoader';
import NoProspect from '../NoProspect';
import { getProspectsByStatus, getViewAllProspects } from '../../../utils/api';

const SwitchView = (() => {
  const { setError, cleanToastBanner } = useError();
  const [{
    page, callApi, apiBody, records, leadsContent, apptId,
  }, dispatch] = useContext(PmaContext);

  useEffect(() => {
    const fetchLeadContent = async () => {
      try {
        const response = await callApi(getViewAllProspects());
        dispatch({ leadsContent: response.jsonObject });
        cleanToastBanner();
      } catch ({ error }) {
        setError(error);
      }
    };
    fetchLeadContent();
    // eslint-disable-next-line
  }, []);


  const dispatchObject = (response) => {
    const hasNextPage = response.records.length < 20 ? 'false' : 'true';
    if (!response.hasData) {
      return { page: 'no leads' };
    }

    if (apiBody.pagination.pageIndex) {
      return { records: [...records, ...response.records], page: 'prospect card', hasNextPage };
    }

    if (response.pagination.recordCount) {
      return {
        records: response.records, page: 'prospect card', pageCount: 'false', hasNextPage,
      };
    }
    return { pageCount: 'true', page: 'prospect card' };
  };

  useEffect(() => {
    const fetchProspectData = async () => {
      try {
        const response = await callApi(getProspectsByStatus(apiBody));
        dispatch(dispatchObject(response));
        cleanToastBanner();
      } catch ({ error }) {
        setError(error);
      }
    };
    fetchProspectData();
    // eslint-disable-next-line
  }, [apiBody]);


  if (leadsContent && apptId) {
    // setTracking({ eventType: 'pageview', eventName: 'lmaProfile' });
    return <ProfileContainer />;
  }
  if (leadsContent && page === 'prospect card') {
    // setTracking({ eventType: 'pageview', eventName: 'lmaViewAllLeads' });
    return <RepCardContainer />;
  }
  if (leadsContent && page === 'no leads') {
    // setTracking({ eventType: 'pageview', eventName: 'lmaNoLeads' });
    return <NoProspect {...leadsContent.noLeadsComponents} />;
  }
  return <SkeletonLoader />;
});

export default SwitchView;
